function ConfigService($localStorage) {

  'ngInject';

  this.set = (name, value) => {
    $localStorage[name] = value;
  };

  this.get = (name, defaultValue) => {
    if ($localStorage[name]) {
      return $localStorage[name];
    } else if (defaultValue) {
      return defaultValue;
    }
    return null;
  };

  return {
    set: (name, value) => this.set(name, value),
    get: (name, defaultValue) => this.get(name, defaultValue),
  };
}

export default ConfigService;



// WEBPACK FOOTER //
// ./src/services/Config.js